export enum FinishHandle {
  MS = "ms" as any,
  WG = "wg" as any,
  BK = "bk" as any,
  WH = "wh" as any,
  BZ = "bz" as any,
  SR = "sr" as any,
  HW = "hw" as any,
  MSA = "msa" as any,
  SM = "sm" as any,
  SS = "ss" as any,
  GS = "gs" as any,
  ASH = "ash" as any,
  GBK = "gbk" as any
}

export enum FinishDisplayName {
  MS = "Matte Silver",
  WG = "Golden Oak",
  BK = "Matte Black",
  WH = "Matte White",
  BZ = "Matte Bronze",
  SR = "Polished Anodized Silver",
  HW = "Heather Willow",
  MSA = "Matte Silver Anodized",
  SM = "Silver Mist",
  SS = "Stainless Steel",
  GS = "Galvanized Steel",
  ASH = "Ash Wood",
  GBK = "Gloss Black"
}

export interface Finish {
  handle: FinishHandle;
  display_name: FinishDisplayName;
}
